import axios from 'axios';
import { axiosRequestInterceptor, axiosResponseInterceptor } from './moodleInterceptors';

const stagingEnvironment = 'development';
const testingEnvironment = 'test';
const env = process.env.REACT_APP_ENV;

// const DEVELOPMENT_URL = 'http://keyboarding.pescirrusdev.com'; CORS ERROR
const DEVELOPMENT_URL = process.env.REACT_APP_MOODLE_DEVELOPMENT_URL;
const TESTING_URL = process.env.REACT_APP_MOODLE_TESTING_URL;
const PRODUCTION_URL = process.env.REACT_APP_MOODLE_PRODUCTION_URL;
// base axios instance
// console.log(env);
// console.log(process.env.REACT_APP_MOODLE_DEVELOPMENT_URL);
// console.log(process.env.REACT_APP_MOODLE_TESTING_URL);
// console.log(process.env.REACT_APP_MOODLE_PRODUCTION_URL);

let baseURL;
switch (env) {
  case stagingEnvironment:
    baseURL = DEVELOPMENT_URL;
    break;
  case testingEnvironment:
    baseURL = TESTING_URL;
    break;
  default:
    baseURL = PRODUCTION_URL;
    break;
}
const baseInstance = axios.create({
  baseURL: baseURL,
  timeout: 10000
});

// add interceptors to instance
const attachInterceptors = axiosInstance => {
  axiosInstance.interceptors.request.use(
    axiosRequestInterceptor.onFulfilled,
    axiosRequestInterceptor.onRejected
  );

  axiosInstance.interceptors.response.use(
    axiosResponseInterceptor.onFulfilled,
    axiosResponseInterceptor.onRejected
  );
};

attachInterceptors(baseInstance);

export default baseInstance;
